import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import './GoogleAdsenseSwitcher.css';


const GoogleAdsenseSwitcher = ({
  patchUser,
  me,
}) => {
  const { i18n, t } = useTranslation();
  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('afp_enable', checked);
    patchUser(form);
  };

  let infoURL = 'https://blog.heylink.me/2021/08/03/how-to-earn-money-with-heylink-me-google-adsense-premium-in-2021/';
  if (i18n.language === 'pt') {
    infoURL = 'https://blog.heylink.me/2021/10/29/como-ganhar-dinheiro-com-o-heylink-me-e-o-google-adsense-premium/';
  }

  return (
    <div className="google-adsense-switcher__component">
      <div className="label">
        {t("Google AdSense Premium Access")}
      </div>

      <a
        className="info-icon"
        href={infoURL}
        target="_blank" rel="noopener noreferrer"
      />

      {/*<div className="checkbox-wrapper">*/}
      {/*  <div className="option">OFF</div>*/}
      {/*  <Checkbox*/}
      {/*    toggle*/}
      {/*    checked={me.afp_enable}*/}
      {/*    onChange={onCheckboxChange}*/}
      {/*  />*/}
      {/*  <div className="option">ON</div>*/}
      {/*</div>*/}
    </div>
  );
};

GoogleAdsenseSwitcher.propTypes = {
  patchUser: PropTypes.func.isRequired,
  me: PropTypes.object,
};

GoogleAdsenseSwitcher.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(GoogleAdsenseSwitcher);
